document.addEventListener("DOMContentLoaded", () => {
    const feedbackWrapper = document.querySelector(".feedback");
    const form = document.querySelector(".feedback form");
    if (!form) return;

    const radioInputs = form.querySelectorAll('input[type="radio"]');
    const responseYes = form.querySelector(".feedback__radio-response#yes");
    const responseNo = form.querySelector(".feedback__radio-response#no");
    const feedbackSubmitBtn = form.querySelector(".feedback__submit input");
    const recaptchaExists = form.querySelector(".g-recaptcha");
    let formOpen = false;

    // footer JS in Matrix has callback functions to enable submit button
    if (recaptchaExists) {
        feedbackSubmitBtn.disabled = true;
    }

    // open form function
    function openForm(checked) {
        feedbackWrapper.classList.add("form-active");
        if (checked === "0") {
            responseYes.classList.add("response-active");
        } else if (checked === "1") {
            responseNo.classList.add("response-active");
        }
        formOpen = true;
    }

    // close form function
    function closeForm() {
        feedbackWrapper.classList.remove("form-active");
        responseYes.classList.remove("response-active");
        responseNo.classList.remove("response-active");
        radioInputs.forEach((input) => {
            input.checked = false;
        });
        formOpen = false;
    }

    // open form on radio choice
    form.addEventListener("change", (event) => {
        if (event.target.matches("input[type='radio']")) {
            openForm(event.target.value);
        }
    });

    // close form on close button
    form.addEventListener("click", (event) => {
        if (event.target.matches(".feedback__close-modal")) {
            closeForm();
        }
    });

    // close form on escape key
    document.addEventListener("keydown", (event) => {
        if (event.key === "Escape" && formOpen) {
            closeForm();
        }
    });

    // handle form submission via AJAX
    form.addEventListener("submit", (e) => {
        e.preventDefault();
        const data = new FormData(form);
        fetch(form.getAttribute("action"), {
            method: "POST",
            body: data,
        })
            .then((response) => {
                if (!response.ok) {
                    throw new Error("Form submission failed");
                }
                closeForm();
                return response.text();
            })
            .then((html) => {
                form.innerHTML = html;
            })
            .catch((error) => {
                console.error("Error:", error);
            });
    });
});
